<template>
  <div class="card-content">
    <div class="columns is-multiline">
      <b-field class="has-text-default column is-12">
        <span class="is-italic"> {{ $t('detailFournisseur.infoCompta.compteComptable') }}</span>
        <span class="has-text-weight-semibold mgl-10px">
            {{ fournisseur.compteComptable }}
          </span>
      </b-field>
      <b-field class="has-text-default column is-12" v-if="!(isFactor || isDemarcheur)">
        <span class="is-italic"> {{ $t('detailFournisseur.infoCompta.referenceUniqueMandat') }}
        </span>
        <span class="has-text-weight-semibold mgl-10px">
            {{ fournisseur.referenceUniqueMandat }}
          </span>
      </b-field>
      <b-field class="has-text-default column is-12" v-if="!(isFactor || isDemarcheur)">
        <span class="is-italic"> {{ $t('detailFournisseur.infoCompta.dateSignatureMandatSepa') }}
        </span>
        <span class="has-text-weight-semibold mgl-10px">
            {{ fournisseur.dateSignatureMandatSepa | formatDate }}
          </span>
      </b-field>
    </div>
  </div>
</template>

<script>

export default {
  props: {
    fournisseur: {
      type: Object,
      required: true,
    },
    isFactor: {
      type: Boolean,
      required: false,
      default: false,
    },
    isDemarcheur: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
};
</script>
